import moment from 'moment-timezone';

export const sortByOrderNumber = (a, b) => {
    let lowA = !a.number ? '' : a.number.toLowerCase();
    let lowB = !b.number ? '' : b.number.toLowerCase();
    if (lowA < lowB) {
        return 1;
    }
    if (lowA > lowB) {
        return -1;
    }
    return 0;
};

export const getSorterByField = (field, isAsc, unreadOrderIds) => {
    switch (field) {
        case 'writer_last_graded_at':
        case 'pregrader_created_at':
        case 'available_from':
        case 'final_deadline':
            return (a, b) => {
                let diff = moment(a[field]).diff(moment(b[field]));
                if (!isAsc) {
                    diff *= -1;
                }
                return diff;
            };
        case 'messagesComputed':
            return (a, b) => {
                const hasA = unreadOrderIds.indexOf(a._id) > -1;
                const hasB = unreadOrderIds.indexOf(b._id) > -1;
                if (hasA === hasB) {
                    return 0;
                }
                return !isAsc ? hasA < hasB : hasA > hasB;
            };
        case 'grade_priority':
            return (a, b) => {
                const fixedA = a.grade_priority || 0;
                const fixedB = b.grade_priority || 0;
                let diff = fixedB - fixedA;
                if (isAsc) {
                    diff *= -1;
                }
                return diff;
            };
        default:
            return (a, b) => {
                if (a[field] < b[field]) {
                    return isAsc ? -1 : 1;
                } else if (a[field] > b[field]) {
                    return isAsc ? 1 : -1;
                } else {
                    return 0;
                }
            };
    }
};



// WEBPACK FOOTER //
// ./src/store/orderSorters.js